import { useContext, useMemo } from 'react'
import { UGEContext } from '../../../context'
import Trimmer from '../../../trimmer'
import { Duration, TimeBar, TimeInput } from './style'

type Props = {
    className?: string
}

const UGEDefaultEditorTrim = ({ className }: Props) => {
    const { duration, loaded, trim, setTrim } = useContext(UGEContext)
    const startTime = useMemo(() => trim.start * duration, [duration, trim])
    const endTime = useMemo(() => trim.end * duration, [duration, trim])
    const durationTime = useMemo(() => Math.round((endTime - startTime) * 100) / 100, [endTime, startTime])

    function onStartTimeChange(value: number) {
        setTrim({
            ...trim,
            start: Math.round((value / duration) * 100) / 100,
        })
    }

    function onEndTimeChange(value: number) {
        setTrim({
            ...trim,
            end: Math.round((value / duration) * 100) / 100,
        })
    }

    if (!duration || !loaded) {
        return null
    }

    return (
        <div className={className}>
            <Trimmer />
            <TimeBar>
                <TimeInput
                    format="time"
                    max={endTime}
                    min={0}
                    size="medium"
                    step={0.05}
                    value={startTime}
                    onChange={onStartTimeChange}
                />
                <Duration>{durationTime}s</Duration>
                <TimeInput
                    format="time"
                    max={duration}
                    min={startTime}
                    size="medium"
                    step={0.05}
                    value={endTime}
                    onChange={onEndTimeChange}
                />
            </TimeBar>
        </div>
    )
}

export default UGEDefaultEditorTrim
